import { GET_JWT, GET_REFRESH_JWT, SET_JWT, REMOVE_JWT } from "../constants";
import { REFRESH } from "./user";
import { showToast } from "../utils/utils";

export default {
  query: async (client, query, variables) => {
    try {
      return await client.query({
        query: query,
        variables: variables,
        fetchPolicy: "network-only",
        options: {}
      });
    } catch (error) {
      if (
        error.networkError &&
        error.networkError.result &&
        error.networkError.result.errors &&
        error.networkError.result.errors[0].message === "token damaged" &&
        GET_JWT() &&
        GET_REFRESH_JWT()
      ) {
        const token = GET_JWT();
        REMOVE_JWT();
        try {
          const res = await client.mutate({
            mutation: REFRESH,
            variables: {
              refreshToken: GET_REFRESH_JWT(),
              accessToken: token
            }
          });
          if (res && res.data && res.data.updateAccess) {
            SET_JWT(res.data.updateAccess);
            return await client.query({
              query: query,
              variables: variables,
              fetchPolicy: "network-only",
              options: {}
            });
          }
        } catch (err) {
          showToast("La sesión expiró");
          throw new Error("La sesión expiró");
        }
      }
      throw error;
    }
  },
  mutation: async (client, mutation, variables) => {
    try {
      return await client.mutate({
        mutation: mutation,
        variables: variables
      });
    } catch (error) {
      if (
        error.networkError &&
        error.networkError.result &&
        error.networkError.result.errors &&
        error.networkError.result.errors[0].message === "token damaged" &&
        GET_JWT() &&
        GET_REFRESH_JWT()
      ) {
        const token = GET_JWT();
        REMOVE_JWT();
        try {
          const res = await client.mutate({
            mutation: REFRESH,
            variables: {
              refreshToken: GET_REFRESH_JWT(),
              accessToken: token
            }
          });
          if (res && res.data && res.data.updateAccess) {
            SET_JWT(res.data.updateAccess);
            return await client.mutate({
              mutation: mutation,
              variables: variables
            });
          }
        } catch (err) {
          showToast("La sesión expiró");
          throw new Error("La sesión expiró");
        }
      }
      throw error;
    }
  }
};
